import React from 'react';
import { BiData, BiContextProvidedValue } from '@wix/da-bi/pkg/events';
import ThumbIconButton from '@wix/da-ds/pkg/thumbs/ThumbIconButton';
import { useOverlayContext } from '../../../hooks/useOverlayContext';
import { getDeviationResourceType, getDeviationUrl } from '../../../_helpers';
const CommentControl = ({ deviation , hasCommentedOn , showStatNumbers , className  })=>{
    var _deviation_stats, _deviation_author;
    const { showStats  } = useOverlayContext(deviation);
    var _deviation_author_useridUuid;
    return /*#__PURE__*/ React.createElement(ThumbIconButton, {
        className: className,
        type: "comment",
        isEngaged: hasCommentedOn,
        showStatValue: showStats && showStatNumbers,
        statValue: (_deviation_stats = deviation.stats) === null || _deviation_stats === void 0 ? void 0 : _deviation_stats.comments,
        href: `${getDeviationUrl(deviation)}#comments`,
        biData: BiData({
            evid: 105,
            typeid: getDeviationResourceType(deviation),
            itemid: deviation.deviationId,
            creatorid: (_deviation_author_useridUuid = (_deviation_author = deviation.author) === null || _deviation_author === void 0 ? void 0 : _deviation_author.useridUuid) !== null && _deviation_author_useridUuid !== void 0 ? _deviation_author_useridUuid : '',
            sectionname: BiContextProvidedValue,
            sectionid: BiContextProvidedValue,
            section_typeid: BiContextProvidedValue,
            sectiontype: BiContextProvidedValue,
            sectionrank: BiContextProvidedValue,
            rank: BiContextProvidedValue,
            sort_type: BiContextProvidedValue,
            reason_shown: BiContextProvidedValue,
            widgetname: BiContextProvidedValue
        })
    });
};
CommentControl.displayName = 'CommentControl';
export default CommentControl;
